import type { AuctionCar } from '@autobid/ui/types/Car'
import type { MaybeRef } from 'vue'
import { computed, unref } from 'vue'

export function useShortPlz(car: MaybeRef<AuctionCar>) {
  const shortPlz = computed(() =>
    String(unref(car).additionalInformation.itemLocationCode)
      .split('-')
      .map((el, index) => (index === 0 ? el : el.slice(0, 2)))
      .join('-'),
  )

  return { shortPlz }
}
